Application.Tooltips = {
    ready: function () {

        $('.tooltip-opener').tooltipster({
            theme: 'tooltipster-light'
        });

    }
};